import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';

import { QUERY_KEYS } from 'hb-react/frontoffice/apps/Companies/containers/constants';
import { ITEMS_QUERY_KEYS } from 'hb-react/frontoffice/components/BlocksRenderer/blocks/Items/utils/queryUtils';
import JobFormContainer from 'hb-react/shared/apps/JobForm/containers/JobFormContainer';
import { Provider } from 'hb-react/shared/apps/JobForm/containers/Provider';
import { useRenew } from 'hb-react/shared/apps/JobForm/hooks/useRenew';
import { type JobFormProps } from 'hb-react/shared/apps/JobForm/types';

const JobFormFo = ({
  configPage,
  ...props
}: JobFormProps & { configPage: { menu_name: string } }) => {
  const queryClient = useQueryClient();
  const { opportunityId: jobId } = useParams();
  const navigate = useNavigate();
  const { mode, renew } = props;

  useRenew({ isActive: renew, jobId: Number(jobId) });

  const onSuccess = (companyId?: number) => {
    queryClient.invalidateQueries({
      queryKey: [ITEMS_QUERY_KEYS.jobs.items],
    });
    if (companyId) {
      queryClient.invalidateQueries({
        queryKey: [ITEMS_QUERY_KEYS.companies.jobs.items(companyId)],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.company, companyId],
      });
    }
  };

  return (
    <Provider navigate={navigate} {...props}>
      <JobFormContainer
        configPage={configPage}
        mode={mode}
        onSuccess={onSuccess}
      />
    </Provider>
  );
};

export default JobFormFo;
